import { useTranslation } from "react-i18next";
import { Button } from "../../../../components";

const MissingPickingPiecesSection = ({ onSubmitOrderForReview, isSubmitOrderForReviewDisabled, isHidden = false }) => {
    const { i18n } = useTranslation();

    if (isHidden) return (<></>)

    const isReviewButtonDisabled = isSubmitOrderForReviewDisabled;

    return (
        <section className="bg-white rounded-lg p-4 flex flex-col gap-2 text-lg">
            <h2 className="mb-0 text-2xl font-bold">{i18n.t('generate_shipment.missing_picking_pieces.title')}</h2>
            <p className="mb-0">
                <span className="font-bold">{i18n.t('generate_shipment.missing_picking_pieces.scan_all_products')}</span>
                {i18n.t('generate_shipment.missing_picking_pieces.missing_items')}
            </p>
            <Button
                type="secondary"
                className="w-full"
                onClick={() => onSubmitOrderForReview(true)}
            >
                {i18n.t('generate_shipment.missing_picking_pieces.action_to_error')}
            </Button>

            <Button
                type="secondary"
                className={`w-full ${isReviewButtonDisabled ? 'has-tooltip bg-gray-50 border-gray-200 text-gray-400 cursor-not-allowed opacity-60 shadow-none' : ''}`}
                onClick={() => onSubmitOrderForReview(false)}
                disabled={isReviewButtonDisabled}
            >
                {isReviewButtonDisabled && (
                    <span className="tooltip rounded shadow-lg p-1.5 bg-black text-white -mt-12">
                        {i18n.t('generate_shipment.missing_picking_pieces.action_disabled_tooltip')}
                    </span>
                )}
                {i18n.t('generate_shipment.missing_picking_pieces.action')}
            </Button>
        </section>
    )
}

export default MissingPickingPiecesSection
